import { faEye, faMars, faVenus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { Link } from "react-router-dom"
import { numFixer } from "../../../User/getAllUsers/components/Functions"

export const columnConfig = ({ renderStatePayload }: any) => [
  {
    accessor: "id",
    title: "Id",
    sortable: true,
  },
  {
    accessor: "is_banned",
    title: "Ban Durumu",
    sortable: true,
    render: (is_banned: boolean) => (is_banned ? "Banlı" : "Banlı Değil"),
  },
  {
    accessor: "campaign",
    title: "Kampanya",
    sortable: true,
    render: ({ campaign }: { campaign: string }) => {
      if (!campaign) {
        return <div className="text-center items-center mr-4">No Campaign</div>
      }
      return (
        <Link to={`/campaigns/find/${campaign}`}>
          <div className="text-center items-center mr-4">
            <FontAwesomeIcon icon={faEye} style={{ color: "#005eff" }} />
          </div>
        </Link>
      )
    },
  },
  {
    accessor: "user",
    title: "Kullanıcı",
    sortable: true,
    render: ({ user }: { user: string }) => {
      if (!user) {
        return <div className="text-center items-center mr-4">No User</div>
      }

      return (
        <Link to={`/user/find/${user}`}>
          <div className="text-center items-center mr-4">
            <FontAwesomeIcon icon={faEye} style={{ color: "#005eff" }} />
          </div>
        </Link>
      )
    },
  },
  {
    accessor: "state",
    title: "State",
    sortable: true,
  },
  {
    accessor: "state_payload",
    title: "State Payload",
    sortable: true,
    render: renderStatePayload,
  },
  {
    accessor: "price_user",
    title: "Kullanıcı Tutarı",
    sortable: true,
  },
  {
    accessor: "price_brand",
    title: "Marka Tutarı",
    sortable: true,
  },
  {
    accessor: "age",
    title: "Yaş",
    sortable: true,
    render: ({ age }: { age: number | null }) => <div>{age && age > 65 ? "65" : age}</div>,
  },
  {
    accessor: "gender",
    title: "Cinsiyet",
    sortable: true,
    render: ({ gender }: { gender: string }) => (
      <div className="text-center items-center">
        {gender === "male" ? (
          <FontAwesomeIcon icon={faMars} style={{ color: "#005eff" }} />
        ) : gender === "female" ? (
          <FontAwesomeIcon icon={faVenus} style={{ color: "#ff00dd" }} />
        ) : (
          <div>diğer</div>
        )}
      </div>
    ),
  },
  {
    accessor: "verification",
    title: "Onay Durumu",
    sortable: true,
    render: (verification: boolean) => (verification ? "True" : "False"),
  },
  { accessor: "job", title: "Meslek", sortable: true },
  { accessor: "country", title: "Ülke", sortable: true },
  { accessor: "insta_full_name", title: "IG Tam İsim", sortable: true },
  {
    accessor: "insta_username",
    title: "Insta Kullanıcı Adı",
    sortable: true,
    render: ({ insta_username }: { insta_username: string }) => (
      <a
        href={`https://www.instagram.com/${insta_username}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center items-center">
          <span>{insta_username}</span>
        </div>
      </a>
    ),
  },
  {
    accessor: "tiktok_username",
    title: "TikTok Kullanıcı Adı",
    sortable: true,
    render: ({ tiktok_username }: { tiktok_username: string }) => (
      <a
        href={`https://www.tiktok.com/@${tiktok_username}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center items-center">
          <span>{tiktok_username}</span>
        </div>
      </a>
    ),
  },
  { accessor: "insta_followers", title: "Insta Takipçi", sortable: true },
  { accessor: "insta_average_like", title: "Insta Ortalama Beğeni", sortable: true },
  { accessor: "insta_post_number", title: "Insta Gönderi Sayısı", sortable: true },
  { accessor: "tiktok_followers", title: "TikTok Takipçi", sortable: true },
  { accessor: "tiktok_average_like", title: "TikTok Ortalama Beğeni", sortable: true },
  {
    accessor: "tiktok_engagement_rate",
    title: "TikTok Etkileşim Oranı",
    sortable: true,
    render: ({ tiktok_engagement_rate }: { tiktok_engagement_rate: number | null }) => (
      <div>{numFixer(tiktok_engagement_rate)}</div>
    ),
  },
  { accessor: "tiktok_hearts", title: "TikTok Kalp Sayısı", sortable: true },
]
